import React, { useEffect, useState } from 'react'
import { Select, Button, DatePicker } from 'antd'
import dayjs from 'dayjs'
import Card from '../Card'
import DashboardReport from './InfoSystem'
import ProjectReport from './ProjectReport'
import { countDashBoard } from '../../services/dashboard-service'
import { departmentSearch } from '../../services/cmsservice'
import { removeVietnameseTones } from '../../config-func'

const { RangePicker } = DatePicker

const Dashboard = () => {
  const [selectedTime, setSelectedTime] = useState(null)
  const [activeTab, setActiveTab] = useState(null)
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)
  const [dataCount, setDataCount] = useState(0)
  const [listDepartment, setListDepartment] = useState([])
  const [dates, setDates] = useState(null)
  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null
  })

  async function fetchData() {
    setLoading(true)

    let _dataSource = {}

    const params = {
      // title: filters.title || '',
      // status: filters.status || '',
      //   start_date:
      //     (filters?.date && dayjs(filters?.date[0], 'DD/MM/YYYY').valueOf()) ||
      //     '',
      //   end_date:
      //     (filters?.date && dayjs(filters?.date[1], 'DD/MM/YYYY').valueOf()) || ''
      department_id: filters.department_id || '',
      start_date: filters.startDate,
      end_date: filters.endDate
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await countDashBoard(cleanedData)
      _dataSource = response?.data

      // }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
      setDataCount(_dataSource)
      // setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    // khi vào chưa có ngày thì không fetch, tránh gọi API không cần thiết
    if (!filters.startDate || !filters.endDate) return
    fetchData()
  }, [filters.startDate, filters.endDate, filters.department_id])

  const handleTimeSelection = (type) => {
    let range = null

    switch (type) {
      case 'today':
        range = [dayjs().startOf('day'), dayjs().endOf('day')]
        break
      case 'week':
        {
          const now = dayjs()
          const dayOfWeek = now.day() // 0: CN, 1: T2, ... 6: T7
          const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1
          const monday = now.subtract(diffToMonday, 'day').startOf('day')
          const sunday = monday.add(6, 'day').endOf('day')
          range = [monday, sunday]
        }
        break
      case 'month':
        range = [dayjs().startOf('month'), dayjs().endOf('month')]
        break
      case 'year':
        range = [dayjs().startOf('year'), dayjs().endOf('year')]
        break
      default:
        range = null
    }

    setDates(range)
    handleDateRangeChange(range, type)
  }

  const handleDateRangeChange = (nextDates, tab = 'custom') => {
    if (nextDates) {
      const startDate = nextDates[0].startOf('day').unix()
      const endDate = nextDates[1].endOf('day').unix()
      setSelectedTime({ startDate, endDate })
      setActiveTab(tab)
      setDates(nextDates)
      setFilters((prev) => ({
        ...prev,
        startDate: startDate,
        endDate: endDate
      }))
    } else {
      setSelectedTime(null)
      setActiveTab(null)
      setDates(null)
      setFilters((prev) => ({
        ...prev,
        startDate: null,
        endDate: null
      }))
    }
  }

  const getDepartmentAll = async () => {
    const type = ''
    const page = 1
    const pageSize = 1000
    const body = { type, page, pageSize }
    try {
      const res = await departmentSearch(body)
      setListDepartment(res?.data?.list)
    } catch (err) {}
  }

  useEffect(() => {
    getDepartmentAll()
  }, [])

  return (
    <>
      <Card>
        <h3>Dashboard</h3>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          {/* Dropdown chọn sàn */}
          <span>Sàn</span>
          {/* <Select
          allowClear
            defaultValue=""
            style={{ width: 150 }}
            onChange={(e) => {
              setFilters((prev) => ({
                ...prev,
                department_id: e
              }))
            }}
            showSearch
            filterOption={(input, option) =>
              option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Select.Option value="">Tất cả</Select.Option>
            {listDepartment.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select> */}
          <Select
            allowClear
            defaultValue=""
            style={{ width: 150 }}
            onChange={(e) => {
              setFilters((prev) => ({
                ...prev,
                department_id: e
              }))
            }}
            showSearch
            options={[
              { label: 'Tất cả', value: '' },
              ...listDepartment.map((item) => ({
                label: item.name,
                value: item.id
              }))
            ]}
            filterOption={(input, option) => {
              const inputValue = removeVietnameseTones(input).toLowerCase()
              const optionValue = removeVietnameseTones(
                option?.label || ''
              ).toLowerCase()
              return optionValue.includes(inputValue)
            }}
          />

          {/* Các nút chọn thời gian */}
          <Button
            type={activeTab === 'today' ? 'primary' : 'default'}
            onClick={() => handleTimeSelection('today')}
          >
            Hôm nay
          </Button>
          <Button
            type={activeTab === 'week' ? 'primary' : 'default'}
            onClick={() => handleTimeSelection('week')}
          >
            Tuần này
          </Button>
          <Button
            type={activeTab === 'month' ? 'primary' : 'default'}
            onClick={() => handleTimeSelection('month')}
          >
            Tháng này
          </Button>
          <Button
            type={activeTab === 'year' ? 'primary' : 'default'}
            onClick={() => handleTimeSelection('year')}
          >
            Năm nay
          </Button>
          {/* Date Picker cho khoảng thời gian cụ thể */}
          {/* khoảng cách giữa các nút và date picker là 365 ngày */}
          <RangePicker
            value={dates}
            onChange={handleDateRangeChange}
            onCalendarChange={(val) => setDates(val)}
            disabledDate={(current) => {
              if (!dates) return false
              const [start, end] = dates
              if (start && current.diff(start, 'day') > 365) return true
              if (end && end.diff(current, 'day') > 365) return true
              return false
            }}
            format={'DD/MM/YYYY'}
          />
        </div>
      </Card>
      <DashboardReport data={dataCount} />
      <ProjectReport
        deId={filters.department_id}
        startDate={filters.startDate}
        endDate={filters.endDate}
      />
    </>
  )
}

export default Dashboard
